/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PhoneNumber } from './PhoneNumber';
import type { ShopPaymentChannelDto } from './ShopPaymentChannelDto';
export type FinancierShopUpdateRequest = {
    id: string;
    name: string;
    shopReference?: string;
    address: string;
    lineId?: string;
    financierShopsGroupId?: string;
    facebookUrl?: string;
    phoneNumbers: Array<PhoneNumber>;
    status?: FinancierShopUpdateRequest.status;
    expireAt?: string;
    avatarUrl?: string;
    paymentChannels?: Array<ShopPaymentChannelDto>;
};
export namespace FinancierShopUpdateRequest {
    export enum status {
        ACTIVE = 'ACTIVE',
        WAITING_FOR_APPROVE = 'WAITING_FOR_APPROVE',
        EXPIRED = 'EXPIRED',
        SUSPENDED = 'SUSPENDED',
    }
}

